import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 *
 * @deprecated This endpoint shouldn't be used; please use getCompanyAppversionV2 instead.
 *
 * Get a list of CoPilot app versions available in the account
 * @returns Array of app version strings
 */
export function getCompanyAppversion(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.resolve(this).companyAppversionUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z
        .array(z.unknown())
        .transform((array) => array.filter((item) => typeof item === 'string'))
    )
  );
}
